import { render } from "./FehlerMarkieren.vue?vue&type=template&id=194e353f&scoped=true"
import script from "./FehlerMarkieren.vue?vue&type=script&lang=js"
export * from "./FehlerMarkieren.vue?vue&type=script&lang=js"

import "./FehlerMarkieren.vue?vue&type=style&index=0&id=194e353f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-194e353f"]])

export default __exports__